import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import { fetchData } from "./helpers";

import Row from "./Row";
import Wrapper from "./Wrapper";

const MovieDupes = ({ setTitle }) => {
    const [loading, setLoading] = useState(false);
    const [dupes, setDupes] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState("");

    useEffect(() => {
        setTitle("Movie dupes");
        setLoading(true);
        fetchData({
            endpoint: "dupes/list",
            handleComplete: (response) => {
                setDupes(response.data);
                setLoading(false);
            },
        });
    }, []);

    const filteredDupes = dupes.filter(dupe => {
        const searchValue = search.trim();
        if (!searchValue) return true;
        return (
            dupe.current_id.toString().includes(searchValue) ||
            dupe.next_id.toString().includes(searchValue)
        );
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedDupes = filteredDupes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Wrapper loading={loading}>
            <TextField
                label="Search by Current or Next Movie ID"
                variant="outlined"
                fullWidth
                margin="normal"
                value={search}
                onChange={e => {
                    setSearch(e.target.value);
                    setPage(0);
                }}
            />
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Current movie ID</TableCell>
                        <TableCell>Next movie ID</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Row addNewDupe={(nextDupe) => setDupes([nextDupe, ...dupes])} />
                    {paginatedDupes.map((dupe) => (
                        <Row key={dupe.id} dupe={dupe} />
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                component="div"
                count={filteredDupes.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
            />
        </Wrapper>
    );
};

export default MovieDupes;